/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Est_TotalInputs */



/**
* | output |
* | --- |
* | "Estimated total" |
*
* @param {Partner_Dashboard_Detail_Est_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_est_total = /** @type {((inputs?: Partner_Dashboard_Detail_Est_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Est_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschätzte Gesamtsumme")
	return /** @type {LocalizedString} */ ("Estimated total")
});